var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-report"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ASP成果インポート・エクスポート")])])],1),_c('Tools02ReportImport',{attrs:{"toolId":_vm.toolId}}),_c('Tools02ReportExport',{attrs:{"toolId":_vm.toolId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }